import { render, staticRenderFns } from "./FeedbackSection.vue?vue&type=template&id=3339dd64&"
import script from "./FeedbackSection.vue?vue&type=script&lang=js&"
export * from "./FeedbackSection.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports